import { render, staticRenderFns } from "./trade-detail.vue?vue&type=template&id=1732cbe0"
import script from "./trade-detail.vue?vue&type=script&lang=js"
export * from "./trade-detail.vue?vue&type=script&lang=js"
import style0 from "./trade-detail.vue?vue&type=style&index=0&id=1732cbe0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports